/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `pending_approval` - Pending Approval
 * * `approved` - Approved
 * * `denied` - Denied
 */
export enum FacilityStatusEnum {
    PENDING_APPROVAL = 'pending_approval',
    APPROVED = 'approved',
    DENIED = 'denied',
}
